const value = Object.freeze({
  ReferralServiceAT: 23,
  QuoteSheet: 246,
  OtherAt: 247,
  SingleFileDigitization: 1587,
});
export default value;
